import React from 'react';

export function ERHButton({ className, children,  outline, round=true ,...rest }) {
  return (
      <button className={`ERH-btn ${className} ${outline && 'outline'} ${round && 'round'}`} {...rest}
      > {children} </button>
   );
}
